import React from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import Link from 'components/Link';
import Text from 'components/Text';
import { colors } from 'theme';
import { LANGUAGES } from 'utils/constants';
import { createCookie } from 'utils/cookies';

import LanguageIcon from 'language-selection.svg';

const StyledLanguageIcon = styled(LanguageIcon)`
  width: 16px;
  height: 16px;
  opacity: 0.7;
`;
const DisabledLink = styled(Text)`
  color: ${colors.middleGrey};
  opacity: 0.5;
  cursor: auto;
`;

function LanguageLinks({
  className,
  url,
  showIcon = true,
}: {
  className?: string;
  url: Record<string, string>;
  showIcon?: boolean;
}) {
  return (
    <div className={className}>
      {showIcon && <StyledLanguageIcon />}
      {Object.keys(LANGUAGES).map((key) =>
        key !== CURRENT_LOCALE && url[key] ? (
          <Link
            key={key}
            href={url[key] || null}
            data-qa-id={`locale-link-${key}`}
            onClick={() => createCookie('_LOCALE_', key, 1825)}
          >
            {LANGUAGES[key]}
          </Link>
        ) : (
          <DisabledLink
            data-qa-id={`disabled-locale-link-${key}`}
            key={key}
            title={
              !url[key]
                ? sprintf(
                    getText(
                      'This page is currently not available in %(language)s'
                    ),
                    {
                      language: LANGUAGES[key],
                    }
                  )
                : ''
            }
          >
            {LANGUAGES[key]}
          </DisabledLink>
        )
      )}
    </div>
  );
}

// eslint-disable-next-line import/no-default-export
export default LanguageLinks;
